import React, { useState } from 'react';
import * as Styles from 'components/manage-vm/settings-panel/SettingsPanel.style';
import CustomButton from 'components/common/custom-button';
import { Grid } from '@mui/material';
import hooks from 'hooks';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading/Heading';
import Toggle from 'components/common/toggle';
import LoadingImage from 'assets/images/loading.svg';
import Select from 'components/select';
import { useMutation, useQuery } from 'react-query';
import { INFO_ACTION, INSTANCE_ACTION } from 'components/manage-vm/queries';
import Loading from 'components/common/loading';
import { Base64 } from 'js-base64';

const FirewallStep1 = (props) => {
  const { t } = useTranslation();
  const { data, managerVmRefetch } = props;
  const { mutationProps } = hooks();
  const [publicIpv4GlobalEnabled, setPublicIpv4GlobalEnabled] = useState(data?.fw_ipv4_enabled == 1 ? true : false);
  const [publicIpv6GlobalEnabled, setPublicIpv6GlobalEnabled] = useState(data?.fw_ipv6_enabled == 1 ? true : false);
  const [isIpv4FirewallTemp, SetIsIpv4FirewallTemp] = useState(false);
  const [selectedFirewallTemp, setSelectedFirewallTemp] = useState('');
  const { data: vsFirewall, isLoading: firewallLoading } = useQuery('/vs/firewall', {
    onSuccess: (res) => {
      const firstValue = res?.firewall_ruleset?.[0]?.id;
      setSelectedFirewallTemp(firstValue);
    },
  });
  const { mutate: refreshServer, isLoading: refreshServerLoading } = useMutation(INSTANCE_ACTION);
  const { mutate: addipv4FirewallTemp, isLoading: addipv4FirewallTempLoading } = useMutation(INFO_ACTION);
  const handleIpv4GlobalToggle = async (e) => {
    const isEnabled = e.target.checked;
    setPublicIpv4GlobalEnabled(isEnabled);
    await refreshServer(
      { id: data.id, action: isEnabled ? 'enableipv4globalfw' : 'disableipv4globalfw' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            setPublicIpv4GlobalEnabled(data?.fw_ipv4_enabled == 1 ? true : false);
          },
        }),
      },
    );
  };
  const handleIpv6GlobalToggle = async (e) => {
    const isEnabled = e.target.checked;
    setPublicIpv6GlobalEnabled(isEnabled);
    await refreshServer(
      { id: data.id, action: isEnabled ? 'enableipv6globalfw' : 'disableipv6globalfw' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            setPublicIpv6GlobalEnabled(data?.fw_ipv6_enabled == 1 ? true : false);
          },
        }),
      },
    );
  };
  const handleIpv4FirewallTemp = async (e) => {
    const isEnabled = e.target.checked;
    SetIsIpv4FirewallTemp(isEnabled);
    await refreshServer(
      { id: data.id, action: isEnabled ? 'enableipv4fw' : 'disableipv4fw' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            SetIsIpv4FirewallTemp(data?.public_ipv6_vlan == 1 ? true : false);
          },
        }),
      },
    );
  };
  const submitIpv4FirewallTemp = async () => {
    await addipv4FirewallTemp(
      { instance_id: data.id, id: selectedFirewallTemp, action: 'assignipv4fw' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            setSelectedFirewallTemp(vsFirewall?.firewall_ruleset?.[0].id);
            managerVmRefetch();
          },
        }),
      },
    );
  };

  if (firewallLoading) {
    return <Loading gap={50} />;
  }

  return (
    <Styles.InfoDetail>
      <div className="first">
        <Grid container>
          <Grid xs={12}>
            <Styles.PublicMargin>
              <Heading small name={'vs/instance.string232'} />
            </Styles.PublicMargin>
          </Grid>
          <Grid xs={12}>
            <Styles.PublicMarginLeft>
              <div className={`pt-2 d-flex align-items-center`}>
                <div className="pt-2 pr-3">
                  <Toggle handleChange={handleIpv4GlobalToggle} value="active" checked={publicIpv4GlobalEnabled} />
                </div>
                <Styles.PublicIPParaH6>
                  {t(`vs/instance.string233`)}
                  {refreshServerLoading && <img src={LoadingImage} width={20} />}
                </Styles.PublicIPParaH6>
              </div>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
        <Grid container>
          <Grid xs={12}>
            <Styles.PublicMargin>
              <Heading small name={'vs/instance.string234'} />
            </Styles.PublicMargin>
          </Grid>
          <Grid xs={12}>
            <Styles.PublicMarginLeft>
              <div className={`pt-2 d-flex align-items-center`}>
                <div className="pt-2 pr-3">
                  <Toggle handleChange={handleIpv6GlobalToggle} value="active" checked={publicIpv6GlobalEnabled} />
                </div>
                <Styles.PublicIPParaH6>
                  {t(`vs/instance.string235`)}
                  {refreshServerLoading && <img src={LoadingImage} width={20} />}
                </Styles.PublicIPParaH6>
              </div>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
      </div>
      <div className="second" style={{ marginTop: '0' }}>
        <Grid container>
          <Grid xs={12}>
            <Styles.PublicMargin>
              <Heading small name={'vs/instance.string236'} />
            </Styles.PublicMargin>
          </Grid>
          <Grid xs={12}>
            <Styles.PublicMarginLeft>
              <div className={`pt-2 d-flex align-items-center`}>
                <div className="pt-2 pr-3">
                  <Toggle handleChange={handleIpv4FirewallTemp} value="active" checked={isIpv4FirewallTemp} />
                </div>
                <Styles.PublicIPParaH6>
                  {t(`vs/instance.string237`)}
                  {refreshServerLoading && <img src={LoadingImage} width={20} />}
                </Styles.PublicIPParaH6>
              </div>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
        <Grid container>
          <Grid xs={12}>
            <Styles.PublicMargin>
              <Heading isIcon={false} small name={'vs/instance.string239'} />
            </Styles.PublicMargin>
          </Grid>
          <Grid xs={12}>
            <Styles.PublicMarginLeft>
              <Styles.AddingIP>
                <div className="flex-gap">
                  <Select
                    style={{ marginTop: '0px' }}
                    value={selectedFirewallTemp}
                    options={vsFirewall?.firewall_ruleset?.map((item) => ({
                      text: Base64.atob(item.label),
                      value: item.id,
                    }))}
                    name={'selectedIpV6'}
                    onChange={(e) => setSelectedFirewallTemp(e.target.value)}
                  />
                  <CustomButton
                    title={'vs/instance.string238'}
                    buttonStyles={{ height: '3.6rem' }}
                    onClick={submitIpv4FirewallTemp}
                    isLoading={addipv4FirewallTempLoading}
                  />
                </div>
              </Styles.AddingIP>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
      </div>
    </Styles.InfoDetail>
  );
};

export default FirewallStep1;
